import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Login.scss";
import { useUser } from "../../context/UserContext";
import { useNavigate } from "react-router";
import logo from "../../assets/oq-logo-1.svg";

export const Login = (): JSX.Element => {
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { login, validateCookie } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    validateCookie()
      .then((res: boolean) => {
        if (res) {
          window.location.replace("/dashboard");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [validateCookie]);

  const loginSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setPasswordError("");
    setIsSubmitting(true);

    const loginSuccessful = await login(username, password);

    setIsSubmitting(false);
    if (loginSuccessful) {
      navigate("/dashboard");
    } else {
      setPasswordError("Invalid username or password. Please try again.");
    }
  };

  return (
    <div className="login-page" id="loginPage">
      <div className="login-card">
        <Link to="/" className="login-logo" aria-label="OphthalmologyQ home">
          <img src={logo} alt="OphthalmologyQ" />
        </Link>
        <p className="login-tagline">Sign in to your account</p>

        <form onSubmit={loginSubmit} className="login-form">
          <div className="login-field">
            <label htmlFor="login-username">Username</label>
            <input
              id="login-username"
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
            />
          </div>

          <div className="login-field">
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError("");
              }}
              autoComplete="current-password"
            />
          </div>

          <p className="login-forgot">
            <Link to="/forgot-password">Forgot password?</Link>
          </p>

          {passwordError && (
            <p className="login-error" role="alert">
              {passwordError}
            </p>
          )}

          <button
            type="submit"
            className="login-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="login-footer">
          Don’t have an account?{" "}
          <Link to="/sign-up">Sign up</Link>
        </p>
      </div>
    </div>
  );
};
